<script>
  import { onMount, createEventDispatcher, afterUpdate, getContext } from 'svelte';
  import { link, navigate } from 'svelte-routing';

  export let to = '';
  export let Style;
  export let onClick = () => {};
  const confirmDraftStatus = getContext('confirmDraftStatus');

  // function getProps({ location, href, isPartiallyCurrent, isCurrent }) {
  //   const isActive = href === "/" ? isCurrent : isPartiallyCurrent || isCurrent;

  //   // The object returned here is spread on the anchor element's attributes
  //   if (isActive) {
  //     return { class: "active" };
  //   }
  //   return {};
  // }
</script>

<button
  on:click={() => {
    confirmDraftStatus({
      okFunc: () => {
        navigate(to);
        onClick();
      },
    });
  }}
  class="{Style} bg-transparent"
>
  <slot />
</button>
<!-- <Link to="{to}" getProps="{getProps}">

</Link> -->
